/*
  Запись разговора на странице звонка (06.10.2026, строка 128 реестра).

  Звук загружается по кнопке, а не при открытии страницы: каждое прослушивание
  - строка аудит-следа (голос должника - его персональные данные), и открытие
  страницы ради расшифровки не должно записываться как «слушал».

  Проигрыватель - встроенный в браузер: перемотка, громкость и скорость в нём
  уже есть, и свой означал бы второй набор кнопок, которые надо проверять на
  телефоне и читалкой экрана. Звук приходит объектом в памяти, а не адресом:
  иначе отказ сервера стал бы немым проигрывателем без единого слова.
*/

import { useEffect, useState } from 'react'

import { api } from '../api/client.js'
import { Notice } from './Common.jsx'

export default function CallRecording({ communicationId, state, fileName }) {
  const [url, setUrl] = useState(null)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  // Объект в памяти держит весь звук; уйдя со страницы, его надо отпустить.
  useEffect(
    () => () => {
      if (url) URL.revokeObjectURL(url)
    },
    [url],
  )

  if (state === 'saving') {
    return (
      <div className="recording muted">
        Запись разговора сохраняется - обновите страницу через минуту.
      </div>
    )
  }
  if (state !== 'ready') return null

  async function listen() {
    setBusy(true)
    setError(null)
    try {
      const sound = await api.recording(communicationId)
      setUrl(URL.createObjectURL(sound))
    } catch (failure) {
      setError(failure)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="recording">
      {url ? (
        <div className="row">
          {/* Субтитров нет намеренно: текстом служит расшифровка ниже. */}
          <audio className="recording__player" controls autoPlay src={url} />
          <a className="button button--quiet" href={url} download={fileName}>
            Скачать
          </a>
        </div>
      ) : (
        <button type="button" className="button button--quiet" disabled={busy} onClick={listen}>
          {busy ? 'Загружаем запись…' : 'Прослушать запись разговора'}
        </button>
      )}
      <Notice error={error} />
    </div>
  )
}
